import { applyRESTQueries } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function applyBetSlipQuery(message) {
    return applyRESTQueries(ConnectionNames.betslip, message);
}
//# sourceMappingURL=ApplyBetSlipQuery.js.map